import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useTheme } from '@mui/material/styles';
import * as React from 'react';
import { ContentUpdateProps } from '../interface';
import { usePayment } from '../providers/PaymentProvider';
import ChooseCollection from './ChooseCollection';
import ClaimContainer from './ClaimContainer';

export interface CheckTokenContainerProps {
  tokenName?: string;
  content?: ContentUpdateProps;
  logoUrl?: string;
  isLoading?: boolean;
  onClickContinue: () => void;
  onClickSkip: () => void;
}

const CheckTokenContainer = ({
  content,
  tokenName,
  isLoading,
  onClickSkip,
  onClickContinue
}: CheckTokenContainerProps) => {
  const theme = useTheme();
  const { isSkipLoading } = usePayment();

  return (
    <Box>
      <ClaimContainer
        title={content?.title || 'Check Token'}
        description={
          content?.description ||
          `Congrats - as a holder of ${tokenName}, ${
            content?.seriesName ? `you can collect from ${content?.seriesName}` : 'you have access to this membership'
          }.`
        }
      />
      <ChooseCollection />
      <Button
        disabled={isLoading || isSkipLoading}
        startIcon={
          isLoading &&
          !isSkipLoading && (
            <CircularProgress
              sx={{
                color: theme?.palette?.text?.primary
              }}
              size="14px"
            />
          )
        }
        sx={{
          width: '100%',
          marginTop: '20px',
          textTransform: 'none'
        }}
        onClick={onClickContinue}
      >
        Continue with selection
      </Button>
      <Button
        disabled={isLoading || isSkipLoading}
        sx={{
          width: '100%',
          marginTop: '16px',
          background: theme.palette?.background?.paper,
          color: theme.palette?.primary?.main,
          border: `1px solid ${theme.palette?.primary?.main}`
        }}
        startIcon={
          isSkipLoading && (
            <CircularProgress
              sx={{
                color: theme?.palette?.text?.primary
              }}
              size="14px"
            />
          )
        }
        onClick={onClickSkip}
      >
        Skip
      </Button>
    </Box>
  );
};

export default CheckTokenContainer;
